<template>
  <div>
    <form
      class="tw-w-full md:tw-w-4/5 tw-mx-auto tw-rounded tw-overflow-hidden tw-shadow-lg tw-mt-12 tw-p-8 tw-text-left"
    >
      <p class="tw-font-semibold tw-text-xl tw-tracking-tight tw-text-center">
        Enter your company details
      </p>
      <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-6 tw-mt-8">
        <div class="tw-w-full tw-mb-6 md:tw-mb-0">
          <label
            class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
            for="title"
          >
            Company Name
          </label>
          <input
            class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none "
            id="title"
            type="text"
            placeholder="e.g Cadbury PLC"
            v-model="data.name"
          />
        </div>
        <p v-if="errors.name" class="tw-text-xs tw-text-red-500">
          Please enter a company name
        </p>
      </div>

      <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-6 tw-mt-8">
        <div class="tw-w-full tw-mb-6 md:tw-mb-0">
          <label
            class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
            for="title"
          >
            Company Address
          </label>
          <input
            class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none "
            id="title"
            type="text"
            placeholder="e.g 234 Herbert Maculey Way Yaba"
            v-model="data.address"
          />
        </div>
        <p v-if="errors.address" class="tw-text-xs tw-text-red-500">
          Please enter a company address
        </p>
      </div>

      <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-6 tw-mt-8">
        <div class="tw-w-full tw-mb-6 md:tw-mb-0">
          <label
            class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
            for="description"
          >
            Area of Business Operation
          </label>
          <input
            class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none "
            id="title"
            type="text"
            placeholder="e.g Bioenergy"
            v-model="data.operation"
          />
        </div>
        <p v-if="errors.operation" class="tw-text-xs tw-text-red-500">
          Please enter area of operation
        </p>
      </div>

      <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-6 tw-mt-8">
        <div class="tw-w-full tw-mb-6 md:tw-mb-0">
          <label
            class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
            for="title"
          >
            Project Sector
          </label>
          <div class="tw-relative">
            <select
              class="tw-block tw-appearance-none tw-w-full tw-bg-gray-200 tw-border tw-border-gray-200 tw-text-gray-700 tw-py-3 tw-px-4 tw-pr-8 tw-rounded tw-leading-tight focus:tw-outline-none  focus:tw-border-gray-500"
              id="grid-state"
              v-model="data.sector"
            >
              <option disabled value="undefined">Select an option</option>
              <option value="Energy">Energy</option>
              <option value="Solid Waste">Solid Waste</option>
              <option value="Transportation">Transportation</option>
              <option value="Technology">Technology</option>
              <option value="Buildings">Buildings</option>
              <option value="Agriculture and Forestry (REDD)"
                >Agriculture and Forestry (REDD)</option
              >
            </select>
            <div
              class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-px-2 tw-text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
        <p v-if="errors.sector" class="tw-text-xs tw-text-red-500">
          Please select project sectoe
        </p>
      </div>

      <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-6 tw-mt-8">
        <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
          <div class="tw-px-2">
            <label
              class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
              for="contact_name"
            >
              Please enter contact name
            </label>
            <input
              class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none "
              id="contact_name"
              type="email"
              placeholder="e.g Jane Doe"
              v-model="data.contact_name"
            />
            <p v-if="errors.contact_name" class="tw-text-xs tw-text-red-500">
              Please enter name of contact
            </p>
          </div>
        </div>

        <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
          <div class="tw-px-2">
            <label
              class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
              for="contact_number"
            >
              Please enter contact phone number
            </label>
            <input
              class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none "
              id="contact_number"
              type="text"
              placeholder="e.g 08103374289"
              v-model="data.contact_number"
            />
            <p v-if="errors.contact_number" class="tw-text-xs tw-text-red-500">
              Please enter contact number
            </p>
          </div>
        </div>
      </div>

      <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-6 tw-mt-8">
        <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
          <div class="tw-px-2">
            <label
              class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
              for="contact_email"
            >
              Please enter contact email address
            </label>
            <input
              class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none "
              id="contact_email"
              type="email"
              placeholder="e.g Google Nigeria"
              v-model="data.contact_email"
            />
            <p v-if="errors.contact_email" class="tw-text-xs tw-text-red-500">
              Please enter email of contact
            </p>
          </div>
        </div>

        <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
          <div class="tw-px-2">
            <label
              class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
              for="date"
            >
              Please enter audit request date
            </label>
            <input
              class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none "
              id="date"
              type="date"
              placeholder="e.g Google Nigeria"
              v-model="data.audit_date"
            />
            <p v-if="errors.audit_date" class="tw-text-xs tw-text-red-500">
              Please enter audit date
            </p>
          </div>
        </div>
      </div>
      <vue-element-loading
        v-if="loading"
        :active="loading"
        :is-full-screen="true"
      />

      <button
        @click.prevent="submit"
        class="tw-bg-eko-light hover:tw-bg-eko-dark tw-text-white tw-font-bold tw-mt-3 tw-py-2 tw-px-4 tw-rounded focus:tw-outline-none focus:tw-shadow-outline"
        type="button"
      >
        Submit
      </button>
    </form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      user: {},
      token: "",
      data: {},
      errors: {},
      filesUploaded: [],
      loading: false,
      files: [],
      ideas: [],
      file: null,
      id: null,
      company: {},
      res: null,
    };
  },
  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
  },
  methods: {
    submit() {
      this.errors = {};
      this.loading = true;
      let deny = false;
      if (!this.data.name) {
        this.errors.name = true;
        deny = true;
      }
      if (!this.data.address) {
        this.errors.address = true;
        deny = true;
      }
      if (!this.data.operation) {
        this.errors.operation = true;
        deny = true;
      }
      if (!this.data.sector) {
        this.errors.sector = true;
        deny = true;
      }

      if (!this.data.contact_name) {
        this.errors.contact_name = true;
        deny = true;
      }

      if (!this.data.contact_email) {
        this.errors.contact_email = true;
        deny = true;
      }

      if (!this.data.contact_number) {
        this.errors.contact_number = true;
        deny = true;
      }

      if (!this.data.audit_date) {
        this.errors.audit_date = true;
        deny = true;
      }

      if (deny) {
        this.loading = false;
        return;
      }
      this.addProject();
    },

    addProject() {
      this.errors = {};
      const self = this;
      this.data.owner_id = this.user._id;
      axios
        .post(`${this.$baseUrl}/project/audit/create`, this.data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          self.loading = false;
          self.success = true;
          self.data = {};
          self.files = [];
          self.$swal("Success!", "Succesfully", "success");
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    },
  },
};
</script>

<style lang="css" scoped></style>
